import { formatDateToLocalStr } from '../../../../../utils/format/formatDate';

export const getDateDropdownPlaceholder = (
    value: string | null,
    dateFrom: string | null,
    dateTo: string | null,
): string => {
    if (dateFrom && dateTo) {
        return `${formatDateToLocalStr(dateFrom)} - ${formatDateToLocalStr(dateTo)}`;
    }

    if (dateFrom) {
        return `c ${formatDateToLocalStr(dateFrom)}`;
    }

    if (dateTo) {
        return `до ${formatDateToLocalStr(dateTo)}`;
    }

    if (!value) {
        return 'За весь период';
    }

    return value;
};
